module.exports = __webpack_public_path__ + "img/quanwei.e00fdac4.png";